<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">{{__('Credit Notes')}}</h1>
    <div class="mb-6 justify-between items-center topFilterBar">
      <div style="margin-bottom: inherit;">
        <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
          <label class="block text-gray-700">Trashed:</label>
          <select v-model="form.trashed" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="with">With Trashed</option>
            <option value="only">Only Trashed</option>
          </select>
        </search-filter>
      </div>
      <!-- <div style="white-space: nowrap;margin-bottom: inherit;">
        <inertia-link class="btn-indigo" :href="route('creditnotes.create')" v-if="$page.props.auth.user.owner">
          <span>Create</span>
          <span class="hidden md:inline">Credit Note</span>
        </inertia-link>
      </div> -->
    </div>

    <!-- list view -->
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Credit Note No.</th>
          <th class="px-6 pt-6 pb-4">Contact Name</th>
          <th class="px-6 pt-6 pb-4">Contact Email</th>
          <th class="px-6 pt-6 pb-4">Description</th>
          <th class="px-6 pt-6 pb-4">Invoice No. Ref.</th>
          <th class="px-6 pt-6 pb-4">Credit Amout</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Action</th>
        </tr>
        <tr v-for="creditnote in creditnotes.data" :key="creditnote.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 pt-6 pb-4">
              {{ creditnote.credit_note_no }}
           </td>
           <td class="border-t px-6 pt-6 pb-4">
              {{ creditnote.contact.name }}
           </td>
           <td class="border-t px-6 pt-6 pb-4">
              {{ creditnote.contact.email }}
           </td>
          <td class="border-t px-6 pt-6 pb-4">
              {{ creditnote.description }}
           </td>
           <td class="border-t px-6 pt-6 pb-4">
              {{ creditnote.invoice_no_ref }}
           </td>
           <td class="border-t px-6 pt-6 pb-4">
              {{ creditnote.credit_amount}}
           </td>
           <td class="border-t w-px" v-if="$page.props.auth.user.owner">
              <a class="btn-indigo csvbtn" target="_blank" :href="route('creditnotes.pdf', creditnote.id)">
                <span class="hidden md:inline">{{__("PDF")}}</span>
              </a>
            </td>
            <td class="border-t w-px" v-if="$page.props.auth.user.owner">
              <inertia-link class="px-4 flex items-center" :href="route('creditnotes.destroy', creditnote.id)" tabindex="-1" v-if="$page.props.auth.user.owner">
                <icon name="cross" class="block w-6 h-6 fill-red-400" />
              </inertia-link>
          </td>
        </tr>
        <tr v-if="creditnotes.data.length === 0">
          <td class="border-t px-6 py-4" colspan="6">No Credit Notes found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="creditnotes.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Credit Notes' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    creditnotes: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      gridView: true
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('creditnotes'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  mounted(){
    // console.log(this.labels)
  },
  filters: {
  	subStr: function(string) {
        if(string.length > 12){
          return string.substring(0,12) + '..'
        }else{
          return string
        }
      }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(label_id) {
      if (confirm('Are you sure you want to delete this Label?')) {
        this.$inertia.delete(this.route('labels.destroy', label_id))
      }
    },
  },
}
</script>
<style scoped>
.pl-2per{
  padding-left: 2%;
}
.topFilterBar{
  display: flex;
}
.pointer{
  margin-right:4%;
  display: inline-block;
}
span.pointer {
  cursor: pointer;
}

.csvbtn{
  padding: 0.25rem 1rem 0.25rem 1rem;
  margin-right: 1rem;
}
/******************RESPONSIVE***********************/
@media screen and (max-width:500px){
  .topFilterBar{
    display: block;
  }
}
</style>
